import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CurrentPlanCard = ({ currentTier, onUpgrade }) => {
  const tierDetails = {
    free: {
      name: 'Free Trial',
      price: '$0',
      color: 'text-muted-foreground',
      bgColor: 'bg-muted/30',
      icon: 'User',
      features: ['1 book project', 'Basic AI assistance', 'Community access', 'Email support']
    },
    starter: {
      name: 'Starter',
      price: '$49',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      icon: 'Rocket',
      features: ['1 book per month', 'Full AI agent access', 'Skool community', 'Priority support', 'KDP formatting']
    },
    professional: {
      name: 'Professional',
      price: '$99',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      icon: 'Crown',
      features: ['4 books per month', 'Advanced AI features', 'Premium community', 'Priority support', 'Cover design tools', 'Marketing guidance']
    },
    enterprise: {
      name: 'Enterprise',
      price: '$999',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      icon: 'Building',
      features: ['Unlimited books', 'White-glove service', 'Dedicated account manager', '24/7 support', 'Custom AI training', 'Publishing consultation']
    }
  };

  const plan = tierDetails?.[currentTier] || tierDetails?.free;

  return (
    <div className="bg-card border border-border rounded-lg shadow-sm overflow-hidden">
      <div className={`p-6 ${plan?.bgColor}`}>
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className={`w-12 h-12 rounded-lg ${plan?.bgColor} flex items-center justify-center`}>
              <Icon name={plan?.icon} size={24} className={plan?.color} />
            </div>
            <div>
              <h2 className="text-2xl font-heading font-bold text-foreground">{plan?.name}</h2>
              <p className="text-sm text-muted-foreground">Current Plan</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-3xl font-heading font-bold text-foreground">{plan?.price}</p>
            <p className="text-xs text-muted-foreground">per month</p>
          </div>
        </div>

        <div className="space-y-2 mb-6">
          {plan?.features?.map((feature, index) => (
            <div key={index} className="flex items-center space-x-2">
              <Icon name="Check" size={16} className="text-success flex-shrink-0" />
              <span className="text-sm text-foreground">{feature}</span>
            </div>
          ))}
        </div>

        {currentTier !== 'enterprise' && (
          <Button
            variant="default"
            size="default"
            fullWidth
            iconName="TrendingUp"
            iconPosition="right"
            onClick={onUpgrade}
          >
            Upgrade Plan
          </Button>
        )}
      </div>
      <div className="p-4 bg-muted/30 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Next billing date</span>
          <span className="font-mono text-foreground">01/04/2026</span>
        </div>
      </div>
    </div>
  );
};

export default CurrentPlanCard;